import { createFileRoute } from "@tanstack/react-router"
import { CalendarPage } from "./-components/CalendarPage"

export const Route = createFileRoute("/app/my/calendar/")({
  component: CalendarPage,
  beforeLoad: (ctx) => ({
    getTitle: () => ctx.context.t("Calendar"),
  }),
})
